import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ROWS = [
  { key: "onboarding_completion_rate", label: "Onboarding completion rate", suffix: "%" },
  { key: "w1_activation_rate", label: "W1 activation (>=2 sessions, days 1-7)", suffix: "%" },
  { key: "daily_readiness_completion_rate", label: "Daily readiness completion", suffix: "%" },
  { key: "skip_risk_floor_conversion_rate", label: "Skip-risk -> floor conversion", suffix: "%" },
  { key: "week4_completion_rate", label: "Week-4 completion (North Star)", suffix: "%", highlight: true },
];

export default function AdminMetrics() {
  const [metrics, setMetrics] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API}/admin/metrics`)
      .then((r) => r.json())
      .then(setMetrics)
      .catch(() => setError("Could not load metrics."));
  }, []);

  return (
    <div style={{ background: "#0d0a14", color: "#e8e4f0", minHeight: "100vh", fontFamily: "monospace" }} data-testid="admin-metrics-page">
      <div style={{ maxWidth: 720, margin: "0 auto", padding: "40px 24px" }}>
        <h1 style={{ fontSize: 22, marginBottom: 4 }}>Kaizen — Admin Metrics</h1>
        <p style={{ fontSize: 12, opacity: 0.6, marginBottom: 24 }}>Unlinked internal view. Live numbers, no auth gate.</p>

        {error && <p data-testid="admin-metrics-error">{error}</p>}

        {metrics && (
          <>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }} data-testid="admin-metrics-table">
              <tbody>
                {ROWS.map((row) => (
                  <tr key={row.key} style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }} data-testid={`admin-metric-row-${row.key}`}>
                    <td style={{ padding: "10px 8px", opacity: 0.75 }}>{row.label}</td>
                    <td
                      style={{
                        padding: "10px 8px",
                        textAlign: "right",
                        fontWeight: 700,
                        color: row.highlight ? "#B37FE8" : "#e8e4f0",
                      }}
                      data-testid={`admin-metric-value-${row.key}`}
                    >
                      {metrics[row.key]}
                      {row.suffix}
                    </td>
                  </tr>
                ))}
                <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                  <td style={{ padding: "10px 8px", opacity: 0.75 }}>Total users / onboarded</td>
                  <td style={{ padding: "10px 8px", textAlign: "right" }} data-testid="admin-metric-value-user-counts">
                    {metrics.total_users} / {metrics.onboarded_count}
                  </td>
                </tr>
                <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                  <td style={{ padding: "10px 8px", opacity: 0.75 }}>Yellow days served / floor completions</td>
                  <td style={{ padding: "10px 8px", textAlign: "right" }} data-testid="admin-metric-value-yellow-floor">
                    {metrics.yellow_days_served} / {metrics.floor_completions}
                  </td>
                </tr>
              </tbody>
            </table>

            <a
              href={`${API}/admin/metrics-events/export`}
              data-testid="admin-export-csv-link"
              style={{ display: "inline-block", marginTop: 24, color: "#B37FE8", fontSize: 13 }}
            >
              Export metrics_events.csv →
            </a>
          </>
        )}
      </div>
    </div>
  );
}
